import { render, staticRenderFns } from "./Citation.vue?vue&type=template&id=7d4f6b29&scoped=true&"
import script from "./Citation.vue?vue&type=script&lang=js&"
export * from "./Citation.vue?vue&type=script&lang=js&"
import style0 from "./Citation.vue?vue&type=style&index=0&id=7d4f6b29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4f6b29",
  null
  
)

export default component.exports